import { AustralianState, SubmitType } from '@urbanx/agx-ui-components';
import {
  AgxAnimatedToggleLoaderOverlay,
  AgxAnimatedToggleLoaderState,
} from '@urbanx/agx.ui-components2';
import AgencyAgreementGenerating from './AgencyAgreement/AgencyAgreementGenerating';
import AgencyAgreementSubmissionGenerating from './AgencyAgreementSubmission/AgencyAgreementSubmissionGenerating';
import SalesContractGenerating from './SalesContract/SalesContractGenerating';
import SalesContractSubmissionGenerating from './SalesContractSubmission/SalesContractSubmissionGenerating';
import GenerationStatus from './GenerationStatus';
import { FormType } from '@urbanx/agx.campaigns.client';

interface GeneratingPageProps {
  generationStatus: GenerationStatus;
  formType?: FormType;
  submitType?: SubmitType;
  state?: AustralianState;
  onComplete?: () => void;
}

const GeneratingPage = ({
  generationStatus,
  formType,
  submitType,
  state,
  onComplete,
}: GeneratingPageProps) => {
  const getGeneratingPage = (formType?: FormType) => {
    switch (formType) {
      case FormType.MarketingPackageGenerator:
        return (
          <AgencyAgreementGenerating
            generatingText="Generating Package"
            generationStatus={generationStatus}
            submitType={submitType}
          />
        );
      case FormType.ListingGenerator:
        return (
          <AgencyAgreementGenerating generationStatus={generationStatus} submitType={submitType} />
        );
      case FormType.ListingSubmission:
      case FormType.MarketingPackageSubmission:
        return <AgencyAgreementSubmissionGenerating generationStatus={generationStatus} />;
      case FormType.ContractRequest:
        return (
          <SalesContractGenerating
            completeText={submitType === SubmitType.GeneratePdf ? undefined : 'Success'}
            generationStatus={generationStatus}
            generatingText={
              submitType === SubmitType.GeneratePdf ? undefined : 'Submitting Contract Request'
            }
            submitType={submitType}
            state={state}
          />
        );
      case FormType.ContractExchange:
        return (
          <SalesContractGenerating
            generationStatus={generationStatus}
            submitType={submitType}
            state={state}
            generatingText="Generating Contract"
          />
        );
      case FormType.ContractSubmission:
        return <SalesContractSubmissionGenerating generationStatus={generationStatus} />;
      default:
        return undefined;
    }
  };

  const loaderState =
    generationStatus === GenerationStatus.Generated
      ? AgxAnimatedToggleLoaderState.Complete
      : AgxAnimatedToggleLoaderState.Loading;

  return (
    <AgxAnimatedToggleLoaderOverlay
      label={getGeneratingPage(formType)}
      onComplete={onComplete}
      state={loaderState}
    />
  );
};

export default GeneratingPage;
